exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container .roles-table[data-v-37039a8c]{margin-top:30px}.app-container .permission-tree[data-v-37039a8c]{margin-bottom:30px}", ""]);

// exports
